var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullScreenLine = function SvgFullScreenLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.7 3.898h1.8v5.4h-1.8v-3.6h-3.6v-1.8zm-14.4 0h3.6v1.8H5.3v3.6H3.5v-5.4zm14.4 14.4v-3.6h1.8v5.4h-5.4v-1.8zm-14.4 0h3.6v1.8H3.5v-5.4h1.8z"
  })));
};
export default SvgFullScreenLine;